import { ImplementationMissingException } from '@nu-art/ts-common';
import { ModuleFE_Utils } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_OrganizationPermission } from './_entity/organization-permission/ModuleFE_OrganizationPermission.js';
import { Component_OrganizationPermissionEditor } from './organization-permission-editor/Component_OrganizationPermissionEditor.js';
import { OrganizationPermissionAssertionKey, OrganizationPermissionEditorKey } from '@app/org-permissions-shared';
import { RendererKey_AccountMenu_SubHeader } from '@nu-art/user-account-frontend/consts';
import { Renderer_OrgPermissionNames } from './_entity/organization-permission/ui/renderers.js';
export const addOrgPermissionsFE = (module) => {
    // @ts-ignore
    if (module.ModuleFE_BaseDB === undefined) //ignore modules that are received but are not collection modules
        return module;
    const newModule = module;
    if (!newModule.dbDef.generatedProps)
        throw new ImplementationMissingException(`DBDef of ${newModule.dbDef.dbKey} is missing generatedProps field.`);
    newModule.dbDef.generatedProps = [...newModule.dbDef.generatedProps, 'meta'];
    return newModule;
};
//register organization permission editor to generic editor renderer
ModuleFE_Utils.registerRenderer(OrganizationPermissionEditorKey, Component_OrganizationPermissionEditor);
ModuleFE_Utils.registerProcessors(OrganizationPermissionAssertionKey, ModuleFE_OrganizationPermission.getOrgPermissionLevel);
//registering user menu role renderer
ModuleFE_Utils.registerRenderer(RendererKey_AccountMenu_SubHeader, Renderer_OrgPermissionNames);
//# sourceMappingURL=organization-permission-module-fe.js.map